import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger } from '@/components/ui/select';

interface GenderSelectProps {
  value: string;
  onChange: (value: string) => void;
  error?: string;
}

export function GenderSelect({ value, onChange, error }: GenderSelectProps) {
  return (
    <div className="space-y-2">
      <Select value={value || "placeholder"} onValueChange={onChange}>
        <SelectTrigger>
          {value ? value === 'male' ? 'ذكر' : 'أنثى' : 'اختر الجنس'}
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="male">ذكر</SelectItem>
          <SelectItem value="female">أنثى</SelectItem>
        </SelectContent>
      </Select>
      {error && <p className="text-sm text-red-500">{error}</p>}
    </div>
  );
}